"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleButtonOverrides = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var toggleButtonOverrides = {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: function root(_ref) {
        var _ref$ownerState = _ref.ownerState,
          disabled = _ref$ownerState.disabled,
          orientation = _ref$ownerState.orientation,
          _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          shape = _ref$theme.shape,
          spacing = _ref$theme.spacing;
        return {
          padding: spacing(0.25),
          borderRadius: shape.borderRadius,
          background: disabled ? palette.action.disabledBackground : palette.action.disabled,
          '& .MuiToggleButtonGroup-grouped': _objectSpread({}, orientation === 'horizontal' && {
            '&:not(:first-of-type)': {
              borderTopLeftRadius: shape.borderRadius,
              borderBottomLeftRadius: shape.borderRadius
            },
            '&:not(:last-of-type)': {
              borderTopRightRadius: shape.borderRadius,
              borderBottomRightRadius: shape.borderRadius
            }
          })
        };
      }
    }
  },
  MuiToggleButton: {
    styleOverrides: {
      root: function root(_ref2) {
        var _ref2$theme = _ref2.theme,
          breakpoints = _ref2$theme.breakpoints,
          palette = _ref2$theme.palette,
          spacing = _ref2$theme.spacing,
          typography = _ref2$theme.typography;
        return _objectSpread(_objectSpread({}, typography.action), {}, {
          border: 'none',
          color: palette.grey[700],
          '&:hover': {
            background: palette.grey[200]
          },
          '&.Mui-selected': {
            color: palette.grey[700],
            zIndex: 1,
            background: palette.common.white,
            '&:hover': {
              background: palette.grey[50]
            },
            '&.Mui-disabled': {
              color: palette.text.disabled
            }
          },
          '&.Mui-disabled': {
            color: palette.action.disabled,
            border: 'none'
          },
          '&.MuiToggleButton-sizeLarge': {
            padding: "".concat(spacing(1), " ").concat(spacing(3))
          },
          '&.MuiToggleButton-sizeMedium': _defineProperty({
            padding: "".concat(spacing(0.5), " ").concat(spacing(3))
          }, breakpoints.up('tablet'), {
            padding: "".concat(spacing(1), " ").concat(spacing(3))
          }),
          '&.MuiToggleButton-sizeSmall': {
            padding: "".concat(spacing(0.5), " ").concat(spacing(3))
          },
          '& .MuiSvgIcon-root': {
            fontSize: 16
          }
        });
      }
    }
  }
};
exports.toggleButtonOverrides = toggleButtonOverrides;